export enum FiduciaryTypeEnum {
  PowerOfAttorney = 1,
  Guardianship = 2,
  Trusteeship = 3
}
